<div class="container">
  <div class="container__img">
    <img src="./assets/img/error-not-found.svg" alt="not found image">
  </div>
</div>
